export const BREADCRUMB_LABELS: Record<string, string> = {
  develop: 'API Keys',
  numbers: 'Numbers',
  messaging: 'Messaging',
  'auto-responders': 'Auto Responders',
  tcr: 'TCR',
  'sub-accounts': 'Sub Accounts',
  users: 'Users',
  support: 'Support',
  'ip-whitelist': 'IP Whitelist',
  'account-settings': 'Account Settings',
  'user-settings': 'User Settings',
  forwards: 'Forwards',
  'api-keys': 'API Keys',
  conversations: 'Conversations',
  'send-manual-message': 'Send Manual Message',
  smses: 'SMS Messages',
  mmses: 'MMS Messages',
  'opt-outs': 'Opt Outs',
  brands: 'Brands',
  campaigns: 'Campaigns',
  'create-user': 'Create User',
  'create-sub-account': 'Create Sub Account',
  contacts: 'Contacts',
  contact: 'Contact',
  mfa: 'MFA Enforcement',
  profile: 'Profile',
  security: 'Security',
  appearance: 'Appearance',
};

export const INTERMEDIATE_SEGMENTS = new Set(['smses', 'mmses']);
